import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function NavBar({ user, onSignOut, isPremium }) {
  const navigate = useNavigate();
  const location = useLocation();

  const handleSignOut = () => {
    onSignOut();
    navigate('/');
  };

  if (location.pathname === '/') return null;

  const isActive = (path) => location.pathname === path;

  const navBtn = (path, emoji, label) => ({
    onClick: () => navigate(path),
    style: {
      background: isActive(path) ? '#FFD700' : 'none',
      border: `1px solid ${isActive(path) ? '#FFD700' : '#555'}`,
      color: isActive(path) ? '#000' : '#fff',
      padding: '5px 0',
      borderRadius: '6px',
      cursor: 'pointer',
      fontSize: '18px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      minWidth: 0,
    }
  });

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: 'rgba(0,0,0,0.92)',
      backdropFilter: 'blur(8px)',
    }}>
      {/* Row 1 — Navigation icons */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '6px 12px 4px 12px',
      }}>
        <button {...navBtn('/', '🏠', 'Home')}>🏠</button>
        <button {...navBtn('/grind-cards', '🔥', 'Grind')}>🔥</button>
        <button {...navBtn('/goals', '🎯', 'Goals')}>🎯</button>
        <button {...navBtn('/fargo', '🤼', 'Fargo')}>🤼</button>
        {isPremium && (
          <button {...navBtn('/premium', '🏆', 'Members')}>🏆</button>
        )}
      </div>

      {/* Row 2 — User info and sign out */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '2px 12px 5px 12px',
        borderTop: '1px solid #1a1a1a',
      }}>
        <span style={{
          color: '#666',
          fontSize: '11px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '70%',
        }}>
          👤 {user?.displayName?.split(' ')[0] || user?.email}
        </span>
        <button
          onClick={handleSignOut}
          style={{
            background: 'none',
            border: 'none',
            color: '#555',
            fontSize: '11px',
            cursor: 'pointer',
            padding: '0',
            letterSpacing: '0.5px',
          }}
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}

export default NavBar;